import { useState, useEffect, useContext } from "react";
import WizardContext from "./WizardContext";

/**
 * useSyncedField - Automatically manages field state synced with emittedManifest
 * @param {string} fieldName - The key in emittedManifest to sync with
 * @param {any} defaultValue - Default value if not in emittedManifest
 * @returns {[value, setValue]} - Like useState, but auto-synced to emittedManifest
 */
const useSyncedField = (fieldName, defaultValue) => {
    const context = useContext(WizardContext);

    const [value, setValue] = useState(
        context.emittedManifest?.[fieldName] ?? defaultValue
    );

    // Sync local state when emittedManifest changes (from navigation)
    useEffect(() => {
        setValue(context.emittedManifest?.[fieldName] ?? defaultValue);
    }, [context.emittedManifest, fieldName]);

    // Sync emittedManifest when local state changes
    const setSyncedValue = (newValue) => {
        setValue(newValue);
        context.setEmittedManifest((prev) => ({ ...prev, [fieldName]: newValue }));
    };

    return [value, setSyncedValue];
};

export default useSyncedField;
